export default __webpack_public_path__ + "static/media/logo0151.8a05d549.png";